const OPEN_CLASS = "breaks-display--accent";

function initHero(hero: HTMLElement | null): void {
  if (!hero) {
    return;
  }

  var heroHeading = hero.querySelector<HTMLElement>("h1");

  // add class to last word in heroHeading
  if (heroHeading) {
    const words = heroHeading.textContent?.split(" ");
    if (words && words.length > 0) {
      const lastWord = words.pop();
      heroHeading.innerHTML =
        words.join(" ") +
        (lastWord ? ` <span class="${OPEN_CLASS}">${lastWord}</span>` : "");
    }
  }
}

export function initHeroArea(): void {
  // get the hero element and run the initHero
  const hero = document.querySelector<HTMLElement>(".hero");
  initHero(hero);
}

export default initHeroArea;
